package com.iptvplayer.shared.domain.model

import kotlinx.serialization.Serializable

@Serializable
data class WatchHistory(
    val id: String,
    val userId: String,
    val contentId: String,
    val contentType: ContentType,
    val contentName: String,
    val contentLogoUrl: String? = null,
    val streamUrl: String,
    val resumePositionMs: Long,
    val durationMs: Long? = null,
    val lastWatchedAt: Long,
    /** Set for series episodes: lets Continue Watching auto-advance to the next episode. */
    val seriesSourceId: String? = null,
    val seriesId: Int? = null
)
